import { Button, styled } from "@mui/material";

export const StyledButton = styled(Button)(({ theme }) => ({
  height: "50px",
}));
